import { useMemo } from 'react';

import { useOrderEmployees } from 'api/requests/order/useOrderEmployees';
import { parseFullName } from 'helpers';

export const useManagersForOrder = () => {
  const { employees: employeesApi, loading } = useOrderEmployees();

  const managers = useMemo(
    () =>
      employeesApi.map((admin) => ({
        id: admin.id,
        name: parseFullName(admin),
      })),
    [employeesApi]
  );

  return { managers, loading };
};
